<section class="press-page">
  <header class="press-hero">
    <div class="hero-heading">
      <p class="eyebrow">{{ language.isEnglish ? 'Press · Archives' : 'Presse · Archives' }}</p>
      <h1><span>{{ language.isEnglish ? 'Publications' : 'Parutions' }}</span><em>{{ language.isEnglish ? 'and articles' : 'et articles' }}</em></h1>
    </div>
    <p class="intro">
      <span class="intro-mark" aria-hidden="true"></span>
      <span class="intro-lead">{{ language.isEnglish ? 'Perspectives on' : 'Regards portés' }}<br>{{ language.isEnglish ? 'a living body of work.' : 'sur une œuvre vivante.' }}</span>
      <span class="intro-body">{{ language.isEnglish ? 'A selection of publications exploring the work of Cécile Binsztock.' : 'Une sélection de publications autour du travail de Cécile Binsztock.' }}</span>
    </p>
  </header>

  <div class="press-grid">
    <article class="press-card">
      <div class="press-sheet"><img src="./assets/press/press_8.jpg" alt="Parution presse 8" loading="lazy" /></div>
      <p class="caption">{{ language.isEnglish ? 'Publication' : 'Parution' }} 08</p>
    </article>
    <article class="press-card">
      <div class="press-sheet"><img src="./assets/press/press_7.jpg" alt="Parution presse 7" loading="lazy" /></div>
      <p class="caption">{{ language.isEnglish ? 'Publication' : 'Parution' }} 07</p>
    </article>
    <article class="press-card">
      <div class="press-sheet"><img src="./assets/press/press_6.jpg" alt="Parution presse 6" loading="lazy" /></div>
      <p class="caption">{{ language.isEnglish ? 'Publication' : 'Parution' }} 06</p>
    </article>
    <article class="press-card">
      <div class="press-sheet"><img src="./assets/press/press_5.jpg" alt="Parution presse 5" loading="lazy" /></div>
      <p class="caption">{{ language.isEnglish ? 'Publication' : 'Parution' }} 05</p>
    </article>
    <article class="press-card">
      <div class="press-sheet"><img src="./assets/press/press_4.jpg" alt="Parution presse 4" loading="lazy" /></div>
      <p class="caption">{{ language.isEnglish ? 'Publication' : 'Parution' }} 04</p>
    </article>
    <article class="press-card">
      <div class="press-sheet"><img src="./assets/press/press_3.jpg" alt="Parution presse 3" loading="lazy" /></div>
      <p class="caption">{{ language.isEnglish ? 'Publication' : 'Parution' }} 03</p>
    </article>
    <article class="press-card">
      <div class="press-sheet"><img src="./assets/press/press_2.jpg" alt="Parution presse 2" loading="lazy" /></div>
      <p class="caption">{{ language.isEnglish ? 'Publication' : 'Parution' }} 02</p>
    </article>
    <article class="press-card">
      <div class="press-sheet"><img src="./assets/press/press_1.jpg" alt="Parution presse 1" loading="lazy" /></div>
      <p class="caption">{{ language.isEnglish ? 'Publication' : 'Parution' }} 01</p>
    </article>
  </div>
</section>
